module.exports = __webpack_public_path__ + "assets/img/vr.a7015498.jpg";